import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";

function Affluent() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Affluent"
          title={` <span className="jumbotron-subtitle-2">
                Affluent
              </span>Proposition
             `}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              alrajhi bank Malaysia’s Affluent Banking offers you exclusive
              services tailored specially to your needs. We strive to offer the
              highest standards in complete banking service, which includes
              assigning you a dedicated Relationship Manager who will support
              and guide you through your financial decisions.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className=" col-12 custom-column-2">
                <div className="column-header-2">
                  Embark on the Road to Haramain
                </div>
                <div className="column-subheader-2">
                  <li>
                    Our Personal Financing-i Umrah enables you to perform
                    pilgrimage with peace of mind knowing your finances are well
                    taken care of.{" "}
                  </li>{" "}
                </div>
              </div>
              <div className=" col-12 custom-column-2">
                <div className="column-header-2">
                  Achieve Financial Liberty for a Better Future
                </div>
                <div className="column-subheader-2">
                  <li>
                    Get a full range of Islamic financial solutions, from wealth
                    acceleration to Islamic estate planning
                  </li>
                  <li>
                    Receive invites to financial reviews, wealth webinars, and
                    exclusive customer events.
                  </li>
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">
                  Open new opportunities, with our support
                </div>
                <div className="column-subheader-2">
                  <li>
                    Get preferential rates with our various financing solutions,
                    whether it is to fund your children’s education or to buy
                    your dream house.{" "}
                  </li>{" "}
                </div>
              </div>
              <div className=" col-12 custom-column-2">
                <div className="column-header-2">Other services</div>
                <div className="column-subheader-2">
                  <li>Dedicated Relationship Manager </li>
                  <li>
                    Priority queue privilege at alrajhi bank Malaysia branches{" "}
                  </li>
                  <li>Priority applications for financing facilities</li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4" style={{ paddingRight: "20px" }}>
            <h3>How to be an alrajhi bank Malaysia Affluent Customer</h3>
          </div>
          <div className="col-xl-8">
            <p>
              <li>
                Maintain a Total Relationship Balance (TRB*) of at least
                RM150,000 or more at any given time, or
              </li>
            </p>
            <p>
              <li>
                 Total home financing-i of a minimum of RM1,000,000 or more, or
              </li>
            </p>
            <p>
              <li>
                Credit a net monthly salary of RM17,500 into your alrajhi bank
                Malaysia account on a monthly basis
              </li>
            </p>
            <p>
              *TRB refers to total deposit in any current account-i, savings
              account-i, term deposit account-i and/or investment in any Unit
              Trust Fund with the Bank
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Affluent;
